import Utils from "../../../Utils";

const loadSitesForReport = ({
  userId,
  setLoadingState,
  setAlert,
  setCanRedirectToLogin,
  onSuccess,
}) => {
  setLoadingState({
    applyMask: true,
    text: "Loading sites",
  });

  const fetchSitesSuccess = (res) => {
    setLoadingState({
      applyMask: false,
    });

    const sortedSites = [...res?.data].sort((a, b) =>
      a.name.localeCompare(b.name),
    );

    onSuccess(sortedSites);
  };

  const fetchSitesFailure = (err) => {
    setLoadingState({
      applyMask: false,
    });

    setAlert({
      show: true,
      message: "Failed to load sites. Please try again later.",
      type: "danger",
    });

    console.error("Error fetching sites:", err);

    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };
  // Fetch sites data for the user is commented out for now, as per the requirement
  // Utils.getSitesDataForUsers(userId).then(fetchSitesSuccess, fetchSitesFailure);
  Utils.getAllSitesForReport().then(fetchSitesSuccess, fetchSitesFailure);
};

export const DashboardUtility = {
  loadSitesForReport,
};
